import "./Note.scss"

const Note = ({ type = "error", text = "", style = {}, disabledIcon = false }) => {
  let iconClassName = "fal fa-exclamation-circle"
  let classNames = ["note-container"]

  if (type === "error") {
    classNames.push("error-note")
  } else if (type === "note") {
    classNames.push("note")
  }

  return (
    <div
      className={classNames.join(" ")}
      style={style}
    >
      {disabledIcon === false && <i className={[iconClassName, "note-icon"].join(" ")} />}
      <p className="note-text">{text}</p>
    </div>
  )
}

export default Note
